import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { useApp } from "../../context/AppContext";
import { Page, btnGold, btnGhost } from "../../components/store/ui";
import { ThankYou } from "../../components/store/ThankYou";

export function PaymentSuccess() {
  const [sp] = useSearchParams();
  const { refreshCart, user } = useApp();
  const [st, setSt] = useState({ payment_status: "pending" });
  const [order, setOrder] = useState(null);
  useEffect(() => {
    let n = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sp.get("session_id")}`);
        setSt(data);
        if (data.payment_status === "paid") {
          refreshCart();
          if (data.order) setOrder(data.order);
          return;
        }
        if (data.payment_status === "expired" || data.payment_status === "failed") return;
      } catch { /* retry */ }
      if (++n < 15) timer = setTimeout(poll, 2000);
      else setSt((s) => ({ ...s, timeout: true }));
    };
    poll();
    return () => clearTimeout(timer);
  }, [sp, refreshCart]);
  const paid = st.payment_status === "paid";
  return (
    <Page>
      <div className={paid && order ? "max-w-5xl" : "max-w-lg"} data-testid="payment-status">
        {paid ? <CheckCircle2 className="w-10 h-10 text-[#10B981]" /> : st.timeout || ["expired", "failed"].includes(st.payment_status) ? <XCircle className="w-10 h-10 text-red-400" /> : <Loader2 className="w-10 h-10 animate-spin text-[#C9A96E]" />}
        <h1 className="text-4xl font-extrabold mt-6" data-testid="payment-status-title">
          {paid ? "Merci pour votre commande" : st.timeout ? "Confirmation en attente" : ["expired", "failed"].includes(st.payment_status) ? "Paiement non abouti" : "Vérification du paiement…"}
        </h1>
        <p className="text-muted-foreground mt-4">{paid ? "Votre paiement est confirmé et nous préparons maintenant votre colis avec soin." : "Nous attendons la confirmation de Stripe. Aucun débit n'est considéré comme acquis avant confirmation."}</p>
        {paid && order && <ThankYou o={order} />}
        <div className="flex gap-3 mt-8">
          {st.order_id && <Link to={user ? `/account/orders/${st.order_id}` : "/login"} className={btnGold} data-testid="payment-view-order">{user ? "Suivre ma commande" : "Se connecter pour suivre"}</Link>}
          <Link to="/shop" className={btnGhost}>Boutique</Link>
        </div>
      </div>
    </Page>
  );
}

export function PaymentCancel() {
  return (
    <Page>
      <div className="max-w-lg" data-testid="payment-cancel">
        <XCircle className="w-10 h-10 text-muted-foreground" />
        <h1 className="text-4xl font-extrabold mt-6">Paiement annulé</h1>
        <p className="text-muted-foreground mt-4">Aucun montant n'a été débité. Le stock réservé sera libéré à l'expiration de la session de paiement.</p>
        <Link to="/cart" className={`${btnGold} inline-block mt-8`}>Retour au panier</Link>
      </div>
    </Page>
  );
}
